import {
  Archive,
  ArrowDownUp,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  BadgeDollarSign,
  Ban,
  Banknote,
  Barcode,
  Beaker,
  Bell,
  Boxes,
  Braces,
  Brain,
  Building,
  Building2,
  Calculator,
  Calendar,
  ChartArea,
  ChartBar,
  ChartColumnIncreasing,
  ChartLine,
  ChartPie,
  Check,
  CheckCheck,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleX,
  Clipboard,
  ClipboardList,
  Clock,
  ContactRound,
  CreditCard,
  DollarSign,
  Download,
  Droplet,
  EllipsisVertical,
  EqualApproximately,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileCode,
  FileSpreadsheet,
  FileText,
  FileX,
  FlaskConical,
  Folder,
  FolderOpen,
  Forward,
  Funnel,
  FunnelX,
  Home,
  Hospital,
  IdCard,
  Info,
  Layers,
  LayoutDashboard,
  List,
  ListChecks,
  ListX,
  LoaderCircle,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  Merge,
  MessageCircle,
  MessageSquare,
  Microscope,
  Monitor,
  Moon,
  NotebookPen,
  Package,
  Paperclip,
  PawPrint,
  Pause,
  Pencil,
  Percent,
  Phone,
  Pill,
  Play,
  Plus,
  Printer,
  RefreshCw,
  Reply,
  RotateCcw,
  ReceiptText,
  Rss,
  Save,
  Search,
  SearchCheck,
  Send,
  Settings,
  ShieldAlert,
  ShieldCheck,
  Siren,
  Sparkles,
  SquarePen,
  Star,
  Stethoscope,
  Sun,
  Syringe,
  TabletSmartphone,
  Tag,
  Tags,
  TestTube,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Upload,
  User,
  Users,
  Vibrate,
  VibrateOff,
  Wallet,
  Wrench,
  X
} from 'lucide-angular';

/**
 * Every Lucide icon a page opened over the authenticated layout can render: the layout itself (header,
 * sidebar, menus) and the pages and overlays it mounts (the registry listings, the Caixa…), which
 * resolve icons only from this set — the `AppModule` pick does not reach a lazy route's injector.
 *
 * `LayoutModule` registers exactly this list (`LucideAngularModule.pick(LAYOUT_LUCIDE_ICONS)`). An icon
 * missing here makes lucide-angular throw on the first render, which aborts the rest of the template;
 * inside a menu item it leaves the label without its icon. `layout-icons.spec.ts` renders the
 * Collection Queues listing against exactly this set and checks the list only grows.
 */
export const LAYOUT_LUCIDE_ICONS = {
  Archive,
  ArrowDownUp,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  BadgeDollarSign,
  // US #61932: Inativar on the Hospitais Tasy grid. An icon missing from this pick throws on the
  // first render and takes the rest of the template down.
  Ban,
  Banknote,
  Barcode,
  Beaker,
  Bell,
  Boxes,
  // WI #63044: Braces, FileCode and FileSpreadsheet are formats of the Exportar menu of the registry
  // listings (XML, HTML, Excel); without them the menu item shows its label and no icon.
  Braces,
  Brain,
  Building,
  Building2,
  Calculator,
  Calendar,
  ChartArea,
  ChartBar,
  ChartColumnIncreasing,
  ChartLine,
  ChartPie,
  Check,
  CheckCheck,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  CircleAlert,
  CircleCheck,
  CircleDollarSign,
  CircleX,
  Clipboard,
  ClipboardList,
  Clock,
  // US #62981: the Central de atendimento leaf icon (ATTENDANCE_CENTER_MENU_ICON); tied to the name by
  // attendance-center-menu-icon.spec.ts.
  ContactRound,
  CreditCard,
  DollarSign,
  Download,
  Droplet,
  EllipsisVertical,
  EqualApproximately,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileCode,
  FileSpreadsheet,
  FileText,
  FileX,
  FlaskConical,
  Folder,
  FolderOpen,
  Forward,
  Funnel,
  FunnelX,
  Home,
  Hospital,
  IdCard,
  Info,
  Layers,
  LayoutDashboard,
  List,
  ListChecks,
  ListX,
  LoaderCircle,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  Merge,
  MessageCircle,
  MessageSquare,
  Microscope,
  Monitor,
  Moon,
  NotebookPen,
  Package,
  Paperclip,
  PawPrint,
  Pause,
  Pencil,
  Percent,
  Phone,
  Pill,
  Play,
  Plus,
  Printer,
  RefreshCw,
  Reply,
  RotateCcw,
  ReceiptText,
  Rss,
  Save,
  Search,
  SearchCheck,
  Send,
  Settings,
  ShieldAlert,
  ShieldCheck,
  Siren,
  Sparkles,
  SquarePen,
  Star,
  Stethoscope,
  Sun,
  // US #61577: o ícone do grupo Vacinas. Sem este registro o nome semeado na
  // migration não vira imagem — o host fica vazio, sem erro (RA-15.2 / C-6.2).
  Syringe,
  TabletSmartphone,
  Tag,
  Tags,
  TestTube,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Upload,
  User,
  Users,
  Vibrate,
  VibrateOff,
  Wallet,
  Wrench,
  X
};
